import buttonVariants, { type ButtonVariantProps } from '@discover-ui/button/variants';
import { cn } from '@discover-lib/utils';

export type ToggleVariantProps = Omit<ButtonVariantProps, 'kind'> & {
  kind?: 'outline' | 'white-transparent';
};

export default function toggleVariants({
  kind = 'outline',
  scale = 'md',
  ...props
}: ToggleVariantProps) {
  return cn(
    buttonVariants({ kind, scale, ...props }),
    cn(
      'inline-flex transition-colors data-[state=on]:bg-accent data-[state=on]:text-accent-foreground data-[state=on]:outline-accent'
    )
  );
}
